var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamCare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510 458",
    style: {
      enableBackground: "new 0 0 510 458"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#809595;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161,357.7c-0.6,13.3-9.5,21.9-21.3,21.9c-6.2,0-11.6-2.4-15.8-7.2c-3.5-3.9-5.4-9-5.4-14.8 c0-5.8,2.2-11.2,6.5-15.4c4.1-4.1,9-6,15.1-6c8.5,0,15.1,4.2,18.3,11.4h-7.5c-2.8-3.5-6.6-5.3-11.3-5.3c-3.9,0-7.6,1.5-10.3,4.3 c-2.9,3-4.6,7.1-4.6,11.1c0,4.4,1.5,8.4,4.2,11.2c2.9,3,6.8,4.7,10.7,4.7c6.3,0,11.2-3.3,14.4-10h-18.9v-5.9H161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.5,378.8h-6.4l16.3-41.7h5.9l16.3,41.7H193l-4.6-12.2h-16.2L167.5,378.8z M180.4,344.9l-6,15.8h11.9 L180.4,344.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.9,378.8v-41.7h9l12.1,32.3l12.1-32.3h8.9v41.7h-5.7l0.4-36.2l-13.6,36.2h-4.3l-13.5-36.2l0.4,36.2H201.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.5,379.6c-6.2,0-11.4-2.3-15.5-6.6c-3.9-4.2-5.9-9.3-5.9-15.5c0-5.8,2.2-11,6.3-15.1 c4.1-4.1,9.3-6.2,15.2-6.2c9.7,0,18.1,6.4,20.8,16.7h-11c-2.2-4.1-5.6-6.3-9.7-6.3c-6.2,0-11.1,4.8-11.1,10.9 c0,6.6,5.2,11.7,10.9,11.7c3.9,0,7.4-2.1,9.6-6h11.1C288.5,373.5,280.6,379.6,270.5,379.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.6,378.8h-11.2l16-41.7h8.3l16,41.7h-11.3l-2.1-6h-13.8L301.6,378.8z M310.6,350.7l-4.2,13.4h8.3 L310.6,350.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.6,378.8v-41.7h13.9c4.4,0,7.8,0.3,10.6,2.3c3.7,2.6,5.6,6.5,5.6,11.7c0,6.8-3.5,11.8-9.5,13.4l10.2,14.3 h-12.6l-8-13.4v13.4H331.6z M343.8,356.3c5,0,7.5-1.3,7.5-5c0-3.5-2.2-4.9-6.7-4.9h-2.8v9.9H343.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.1,378.8v-41.7h22.7v9.2h-12.4v6.7h12.4v9.3h-12.4v7.3h12.4v9.2H367.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.3,222.4c-1.1-0.6-2.4-1.1-3.7-1.2c-0.3-0.1-0.6-0.1-0.9-0.1c-0.2,0-0.3-0.1-0.5-0.1h-0.5 c-0.4,0-0.8,0-1.3,0h-81.6c-5.8,0-10.5,4.7-10.5,10.5c0,5.8,4.7,10.5,10.5,10.5h31.7c1,0,1.9,0.9,1.9,1.9c0,0.6-0.3,1.1-0.8,1.5 c-17.4,9.3-39.8,14.9-64.2,14.9c-6,0-11.8-0.3-17.4-1V283c4.9,0.4,9.9,0.6,15,0.6c34.1,0,65-8.3,88.3-21.9l0,0 c0.3-0.2,0.6-0.2,1-0.2c1.1,0,2.1,0.9,2.1,2.1c0,0.2,0,0.4-0.1,0.6l-4.8,13.1c-2.5,6.9,1,14.6,7.9,17.1c1.5,0.6,3.1,0.8,4.6,0.8 c5.4,0,10.5-3.3,12.5-8.7l17.5-47.5C391.3,232.5,388.4,225.4,382.3,222.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.5,132.7c24.7,0,47.2,5.7,64.7,15.1c0,0,11.1,8,16.4,0.3c6-8.8-6-14.2-6-14.2 c-21.6-10.2-48.4-16.2-77.4-16.2c-5.1,0-10.1,0.2-15,0.6v15.5C250.7,133,256.5,132.7,262.5,132.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.1,78c-10.2,0-18.4,8.3-18.4,18.4v201.2c0,10.2,8.3,18.4,18.4,18.4H245V283 c-64.9-4.7-115.3-39.8-115.3-82.4c0-42.6,50.4-77.6,115.3-82.4V78H137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.4,196.5c0,31.4,35.7,57.5,82.7,62.8V133.7C198.1,138.9,162.4,165,162.4,196.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamCare);
export default __webpack_public_path__ + "static/media/GamCare.28c1a963243ce6119eec3d3fe76b8b0c.svg";
export { ForwardRef as ReactComponent };